import type { ILink } from "@core-components/header/NavBar";
import useAppLanguage from "@hooks/language/useAppLanguage";
import { Button, Menu } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
import type React from "react";
import type { ReactNode } from "react";
import { Link } from "react-router";

interface Props {
  label: ILink["label"];
  icon?: ReactNode;
  path?: ILink["path"];
  hiddenFrom?: ILink["hiddenFrom"];
  isMenuItem?: boolean;
}

const ButtonNavbar: React.FC<ILink> = ({
  path,
  label,
  hiddenFrom,
  isMenu,
  menuItems,
}) => {
  const { locationUrlBuilder } = useAppLanguage();

  const NavbarButton = ({
    label,
    icon,
    path,
    hiddenFrom,
    isMenuItem,
  }: Props) => (
    <Button
      className={`font-inter font-medium ${
        isMenuItem ? " default-icon " : "text-primary-light-text"
      }`}
      component={Link}
      fullWidth={isMenuItem}
      fw={"normal"}
      fz={16}
      justify="left"
      leftSection={icon}
      to={locationUrlBuilder(path ?? "#")}
      variant="transparent"
      visibleFrom={hiddenFrom}
    >
      {label}
    </Button>
  );

  if (isMenu) {
    return (
      <div className={`mantine-visible-from-${hiddenFrom}`}>
        <Menu
          shadow="md"
          transitionProps={{ duration: 300, transition: "fade-down" }}
          trigger="click-hover"
        >
          <Menu.Target>
            <Button
              className="w-full font-inter font-medium text-primary-light-text"
              fz={16}
              rightSection={<IconChevronDown size={15} />}
              variant="transparent"
            >
              {label}
            </Button>
          </Menu.Target>
          <Menu.Dropdown className="rounded-md border-2 border-primary-light bg-primary-light">
            {menuItems?.map(({ label, path, icon }) => (
              <Menu.Item
                key={label?.toString()}
                className={"bg-transparent px-4 py-2 hover:bg-transparent"}
              >
                <NavbarButton
                  label={label}
                  icon={icon}
                  path={path}
                  isMenuItem={true}
                />
              </Menu.Item>
            ))}
          </Menu.Dropdown>
        </Menu>
      </div>
    );
  }

  return <NavbarButton label={label} path={path} hiddenFrom={hiddenFrom} />;
};

export default ButtonNavbar;
